import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTooltip } from './Tooltip.definition';
import { chameleonInternalTooltip } from './InternalTooltip/InternalTooltip.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTooltip({ prefix }), chameleonInternalTooltip({ prefix }));
}
